import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface ClubContext {
  unionId: string;
  unionName: string;
  associationId: string;
  associationName: string;
  districtId: string;
  districtName: string;
  /** @deprecated Iglesia ya no es relación principal */
  churchId?: string;
  churchName?: string;
  clubId: string;
  clubName: string;
  /** @deprecated Usar activeSections */
  clubType?: "aventureros" | "conquistadores" | "guias_mayores";
  /** Secciones activas del club */
  activeSections?: string[];
  periodId: string;
  periodYear: number;
}

interface AppState {
  // Current context
  currentContext: ClubContext | null;
  currentPeriodId: string;

  // UI State
  sidebarOpen: boolean;
  theme: "light" | "dark";

  // Actions
  setCurrentContext: (context: ClubContext) => void;
  clearCurrentContext: () => void;
  setCurrentPeriodId: (periodId: string) => void;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setTheme: (theme: "light" | "dark") => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      currentContext: null,
      currentPeriodId: `period_${new Date().getFullYear()}`,
      sidebarOpen: true,
      theme: "light",

      setCurrentContext: (context) => set({ currentContext: context }),

      clearCurrentContext: () => set({ currentContext: null }),

      setCurrentPeriodId: (periodId) => set({ currentPeriodId: periodId }),

      toggleSidebar: () =>
        set((state) => ({ sidebarOpen: !state.sidebarOpen })),

      setSidebarOpen: (open) => set({ sidebarOpen: open }),

      setTheme: (theme) => set({ theme }),
    }),
    {
      name: "app-storage",
      partialize: (state) => ({
        currentContext: state.currentContext,
        currentPeriodId: state.currentPeriodId,
        sidebarOpen: state.sidebarOpen,
        theme: state.theme,
      }),
    },
  ),
);
